import { DefaultLayout } from "components/Layouts";
import { LayoutProps } from "components/Layouts/Layout.types";
import { UserRoles } from "interfaces";
import { selectUserProfile } from "pages/User/userSelectors";
import { FC, ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export const PrivateRoute: FC<{
  children: ReactNode;
  layout?: FC<LayoutProps>;
  authorizedRoles: UserRoles[];
  layoutProps?: { bgColor?: string; lgColumns?: string };
}> = ({ children, layout: ComponentLayout, layoutProps, authorizedRoles }) => {
  const user = useSelector(selectUserProfile);

  const Layout = ComponentLayout || DefaultLayout;
  const layoutStyles = {
    lgColumns: layoutProps?.lgColumns ?? "lg:grid-cols-1",
    bgColor: layoutProps?.bgColor ?? "bg-main"
  };

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (authorizedRoles.includes(user.role)) return <Layout {...layoutStyles}>{children}</Layout>;
  return <Navigate to="/" />;
};
